var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"good-up",on:{"click":function($event){$event.stopPropagation();}}},[_c('canvas',{ref:"cvs",attrs:{"id":"cvs"}})])}
var staticRenderFns = []

export { render, staticRenderFns }